/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow_down': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 6.414l-5.293 5.293-1.414-1.414L8 3.586l6.707 6.707-1.414 1.414z" _fill="#7E8994" fill-rule="evenodd"/>'
  }
})
